import type { BoundsType, SegmentsType, TripSegmentType } from '../models';

export const getTripSegments = (segments: SegmentsType) =>
  segments.filter((segment) => segment.__typename === 'TripSegment') as TripSegmentType[];

export const getSegments = (bounds: BoundsType): SegmentsType => {
  return bounds.flatMap((bound) => bound.segments);
};
